import * as React from 'react';

import * as moment from 'moment';

import './TrackRow.css';

import { ITrack } from '../api';
import TimeFormat from '../lib/TimeFormat';

interface IProps {
  track?: ITrack,
  onPlay: (id: string) => void,
  onEditFilename: (id: string, filename: string) => any,
  selected: boolean,
  style: React.CSSProperties,
}

interface IState {
  filename: string,
}

export class TrackRow extends React.Component<IProps, IState> {
  
  public constructor(props: IProps) {
    super(props);
    this.state = {
      filename: props.track ? props.track.filename : '',
    };
  }

  public componentWillReceiveProps(props: IProps) {
    const newName = props.track ? props.track.filename : '';
    const oldName = this.props.track ? this.props.track.filename : '';
    if (oldName !== newName) {
      this.setState({filename: newName});
    }
  }

  public render() {
    const {
      track,
      selected=false,
      style,
    } = this.props;
    const {
      filename,
    } = this.state;

    return (<div
        className={ "track-row" + (selected ? ' selected' : '')  }
        style={style}
        onDoubleClick={ this.onPlay }>
        <div className="track-row-inner">
          <div className="timestamp">
            { this.timestamp() }
          </div>
          <input
            className="track-id"
            onBlur={this.onFilenameBlur}
            onChange={this.onFilenameChange}
            value={ filename } />
          <div className="track-duration">
            { track ? TimeFormat.toTimestampShort(track.duration_sec) : '' }
          </div>
        </div>
    </div>);
  }

  private onFilenameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {value} = event.currentTarget;
    this.setState({filename: value});
  }

  private onFilenameBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    const {value} = event.currentTarget;
    const {
      track,
      onEditFilename,
    } = this.props;
    if (!track) {
      return;
    }
    if (value === track.filename) {
      return;
    }
    onEditFilename(track.id, value);
  }

  private onPlay = () => {
    const {
      onPlay,
      track,
    } = this.props

    if (track) {
      onPlay(track.id);
    }
  }

  private timestamp(): string {
    const {track} = this.props;
    if (!track) {
      return '';
    }
    const now = moment();
    const when = moment(track.created_at);
    if (now.year() === when.year()) {
      return when.format('D MMM');
    } else {
      return when.format("MM/DD/YY");
    }
  }

}

export default TrackRow;



// WEBPACK FOOTER //
// ./src/components/TrackRow.tsx